<template>
	<div class="panel_shouyin">
		<el-button @click="getData">发送</el-button>
		<el-button @click="getList">获取列表</el-button>
	</div>
</template>
<script>
	export default {
		data(){
			return{
				
			}
		},
		mounted(){
			this.getLife()
		},
		methods: {
			getLife(){
				let params = {
					"keyword": "",
					"applytype": "",
					"categoryId": "",
					"shopId": "",
					"categoryCode": "",
					"pageIndex": 1,
					"pageSize": 10
				}
				this.$http.post('/api/Product/ProductLifeList', params).then(res => {
					if (res.code == 0) {
						console.log(res)
					}
				})
			},
			getList(){
				let params = {
					"pageIndex": 1,
					"pageSize": 10,
					"keyword": "",
					"applytype": "",
					"categoryId": "",
					"shopId": "",
					"categoryCode": "",
				}
				this.$http.post('http://test.huashengchongwu.com:8000/api/product/service/life/list', params).then(res => {
					if (res.code == 0) {
						console.log(res)
					}
				})
			},
			getData(){
				let service_object = []
				let ss = {  // 服务对象
					"service_objectId": '',  // 服务对象编号
					"limit_weight": {
						"min_weight": 1,  // 最小体重
						"max_weight": 2,  // 最大体重
						"enable_weight_limit": 1,  // 启用体重的限制
					},
					"apply_varieties": {  // 品种
						"_id": "60192046032a27edc171f519",
						"name": "特种犬",
						"code": ""
					}, 
					"apply_features": {  // 特征
						"_id": "60192048032a27edc171f51e",
						"name": "短毛",
						"code": ""
					},
					"price": 50,  // 使用价格
					"service_goods": [
						{ // 服务使用的商品
							"goodsType": 0,  // 使用的商品类型 0: 商品 1 医疗
							"goods_id": "5fec3400f639090001d40d3d",   // Ice Towel  毛巾 通用
							"sku_id": "5fec3400f639090001d40d3d-sl-00",  // sku编号
							"additional_charge": 1,  // 是否额外收费 0:不必开 1:必开
							"additional_price": 1,  // 额外收费对应的价格
							"must_use": 1,   // 是否必开 0:不必开 1:必开
						}
					]
				}
				let ss1 = {  // 服务对象
					"service_objectId": '',  // 服务对象编号
					"limit_weight": {
						"min_weight": 3,  // 最小体重
						"max_weight": 5,  // 最大体重
						"enable_weight_limit": 1,  // 启用体重的限制
					},
					"apply_varieties": {  // 品种
						"_id": "60192046032a27edc171f518",
						"name": "普通犬",
						"code": ""
					}, 
					"apply_features": {  // 特征
						"_id": "60192048032a27edc171f51d",
						"name": "长毛",
						"code": ""
					},
					"price": 80,  // 使用价格
					"service_goods": [
						{ // 服务使用的商品
							"goodsType": 0,  // 使用的商品类型 0: 商品 1 医疗
							"goods_id": "5fec3400f639090001d40d3d",   // Ice Towel  毛巾 通用
							"sku_id": "5fec3400f639090001d40d3d-sl-00",  // sku编号
							"additional_charge": 1,  // 是否额外收费 0:不必开 1:必开
							"additional_price": 1,  // 额外收费对应的价格
							"must_use": 1,   // 是否必开 0:不必开 1:必开
						}
					]
				}
				service_object.push(ss)
				service_object.push(ss1)
				let params = {
					"serviceId": "",  // 服务编号 新增为空
					"title": "自定义名称3",  // 名称
					"applytype": "0",  // 使用种类 0:通用 1:猫用 2:犬用
					"join_commission": 0,  // 是否加入提成 是否加入提成 0:不加入 1:加入
					"app_shelves": 0,  // app 上架
					"custom_discount": {
						"allow_custom": 1, // 是否自定义 0不是自定义折扣  1:自定义折扣
						"min_discount": 0.5, // 最低的折扣 0~1之间
					},
					"category_info": {   // 分类
						"_id": "601923f1d8511dfbc24cb2ff",
						"name": "精致洗护",
						"code": "washing",
					},
					"category_list": [    
						{   //  所属上级类别对象叠加（从根节点类别到父节点)
							"_id": "601923f1d8511dfbc24cb2fd",
							"name": "生活服务",
							"code": ""
						}
					],
					"serviceItems": [
						{  // 服务频次
							"frequency_code": "1",  // 服务的频率 数据从字典中的获取, 查询的条件是 class:生活服务,type:生活服务
							"frequency_text": "1小时",  // 服务频次编码 0(天) 1(小时) 2(半小时) 3(次), 请填写 0 1 2 3
							"service_object": service_object,    // 服务频次名称 0(天) 1(小时) 2(半小时) 3(次), 请填写 天 小时 半小时 次
						}
					],
					"shop_info": [
						{
							"shop_id": "5e9412e0b2bfbc089daerr12",
							"shop_name": "金水区店"
						}
					]
				}
				console.log(params)
				this.$http.post('http://test.huashengchongwu.com:8000/api/product/service/life/update', params).then(res => {
					if (res.code == 0) {
						console.log(res)
					}
				})
			}
		},
	}
</script>
<style scoped lang="scss">
</style>
